import axios from 'axios';
import config from 'app/config';


// const devkey = 'bd5f81281b3f5cce36273dac8eeaeba5';
// const out_format = 'json'; // eslint-disable-line camelcase

/**
* Запросы в api ЭлЖур
*
* @param {String} url
* @param {srting} method
* @param {Object} rest
*
*/
const ejApi = (url, method, rest) => {
  const ejApiUrlRe = (config.ejApiUrlReplace && config.ejApiUrlReplace[document.location.hostname])
    || config.ejApiUrl;
  const apiUrl = `${ejApiUrlRe}${url}`;

  return axios({
    url: apiUrl,
    method,
    timeout: 30000,
    ...rest,
  });
};

export default ejApi;
